import React, { useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { ShopButton } from "../ui/shopbutton";
import { Avatar, Box, Typography } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import SpellcheckIcon from '@mui/icons-material/Spellcheck';

// import logo from '../ui/logo.png';
import logo from '../ui/logo2_b.png';


const Navbar = () => {
  const userData = JSON.parse(localStorage.getItem("user") || null);
  console.log("DATA: ", userData);
  const [nav, setNav] = useState(false);

  const links = [

    // {
    //   id: 1,
    //   link: "About",
    //   href: "about",
    // },
    {
      id: 1,
      link: "Community",
      href: !userData ? "signup" : `/chat/${userData?.phone}`
    },
    {
      id: 2,
      link: "Contact",
      href: "contact",
    },
  ];

  return (
    <div className="flex justify-between items-center w-full h-36 px-4 text-darkBrown bg-white sticky nav">
      <div>
        {/* <h1 className="text-5xl font-signature ml-2"><a className="link-underline hover:transition ease-in-out delay-150 hover:underline hover:decoration-solid" href="">Logo</a></h1> */}

        <img src={logo} alt="Logo" className="h-40 my-auto" />

      </div>

      <ul className="hidden md:flex justify-between items-center gap-4">
        {links.map(({ id, link, href }) => (
          <li
            key={id}
            className="nav-links px-4 cursor-pointer capitalize font-medium text-gray-500 hover:scale-105 hover:text-black duration-200 link-underline"
          >
            <a href={href}>{link}</a>
          </li>
        ))}
        <a href={!userData ? "login" : `/store/${userData?.phone}`}>
          <ShopButton size="default" />
        </a>
        <Box class>
          <a href="/teach">
            <Avatar sx={{ bgcolor: 'orange', width: 40, height: 40 }}>
              <Typography variant="h5" sx={{ fontSize: 30, color: 'white' }}>
                S
              </Typography>
            </Avatar>
          </a>
        </Box>
        <Box>
          <a href={!userData ? "login" : `/profile/${userData?.phone}/dashboard`}>
            <Avatar sx={{ width: 40, height: 40, cursor: 'pointer' }}>
              <PersonIcon sx={{ fontSize: 30 }} />
            </Avatar>
          </a>
        </Box>
      </ul>

      <div
        onClick={() => setNav(!nav)}
        className="cursor-pointer pr-4 z-100 text-gray-500 md:hidden"
      >
        {nav ? <FaTimes size={30} /> : <FaBars size={30} />}
      </div>

      {nav && (
        <ul className="flex flex-col justify-center items-center absolute top-0 left-0 w-72 h-screen bg-amber-50 text-gray-500 z-100">
          {links.map(({ id, link }) => (
            <li
              key={id}
              className="px-4 cursor-pointer capitalize py-6 text-4xl"
            >
              <a onClick={() => setNav(!nav)} href={link}>
                {link}
              </a>
            </li>
          ))}
          <a href={!userData ? "signup" : `/store/${userData?.phone}`}>
            <ShopButton size="sm" />
          </a>
        </ul>
      )}
      {nav && (
        <ul className="flex flex-col justify-center items-center absolute top-0 left-0 w-72 h-screen bg-black text-white z-100">
          {links.map(({ id, link }) => (
            <li
              key={id}
              className="px-4 cursor-pointer capitalize py-6 text-4xl"
            >
              <a onClick={() => setNav(!nav)} href={link}>
                {link}
              </a>
            </li>
          ))}
        </ul>
      )}


    </div>
  );
};

export default Navbar;
